var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM6.5 8.5C6.5 9.3 5.8 10 5 10H4V12H2.5V6H5C5.8 6 6.5 6.7 6.5 7.5V8.5ZM11.5 10.5C11.5 11.3 10.8 12 10 12H7.5V6H10C10.8 6 11.5 6.7 11.5 7.5V10.5ZM15.5 7.5H14V8.5H15.5V10H14V12H12.5V6H15.5V7.5ZM9 7.5H10V10.5H9V7.5ZM4 7.5H5V8.5H4V7.5Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.636862fd882ad91a654d29ffe050e777.svg";
export { ForwardRef as ReactComponent };